import React, { useState } from 'react';
import PropTypes from 'prop-types';

const EmailStep = ({ onVerifyEmail, onVerifyGroupCode, onSkipGroupCode, error, loading, noInvitation, email: verifiedEmail }) => {
  const [email, setEmail] = useState('');
  const [groupCode, setGroupCode] = useState('');
  const [showGroupCode, setShowGroupCode] = useState(false);

  const handleEmailSubmit = (e) => {
    e.preventDefault();
    if (email.trim()) {
      onVerifyEmail(email.trim());
    }
  };

  const handleGroupCodeSubmit = (e) => {
    e.preventDefault();
    const emailToUse = verifiedEmail || email.trim();
    if (groupCode.trim()) {
      onVerifyGroupCode(emailToUse, groupCode.trim());
    }
  };

  // Show group code input if no invitation was found
  React.useEffect(() => {
    if (noInvitation) {
      setShowGroupCode(true);
    }
  }, [noInvitation]);

  return (
    <div className="space-y-4">
      {!showGroupCode ? (
        <form onSubmit={handleEmailSubmit} className="space-y-4">
          <div className="text-center mb-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Enter Your Email</h3>
            <p className="text-sm text-gray-600">
              Please enter your email address to verify your invitation
            </p>
          </div>

          {error && !noInvitation && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-600 rounded-lg">
              {error}
            </div>
          )}

          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
              Email Address
            </label>
            <input
              type="email"
              name="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-white text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#1086a4] focus:border-[#1086a4] transition-colors duration-200"
              required
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            disabled={loading || !email.trim()}
            className="w-full py-3 px-4 bg-[#1086a4] hover:bg-[#0c6d85] disabled:bg-gray-400 text-white font-semibold rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1086a4] focus:ring-offset-2 transition-colors duration-200 shadow-sm"
          >
            {loading ? 'Verifying...' : 'Verify Email'}
          </button>
        </form>
      ) : (
        <form onSubmit={handleGroupCodeSubmit} className="space-y-4">
          <div className="text-center mb-6">
            <p className="text-sm text-gray-700">
              If you have a group code, please enter it below to continue registration
            </p>
          </div>

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-600 rounded-lg">
              {error}
            </div>
          )}

          <div>
            <label htmlFor="groupCode" className="block text-sm font-medium text-gray-700 mb-2">
              Group Code
            </label>
            <input
              type="text"
              name="groupCode"
              id="groupCode"
              value={groupCode}
              onChange={(e) => setGroupCode(e.target.value.toUpperCase())}
              placeholder="Enter your group code"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-white text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#1086a4] focus:border-[#1086a4] transition-colors duration-200"
              disabled={loading}
            />
          </div>

          <div className="flex gap-2">
            <button
              type="button"
              onClick={() => {
                setShowGroupCode(false);
                setGroupCode('');
                setEmail('');
              }}
              disabled={loading}
              className="flex-1 py-3 px-4 bg-gray-100 hover:bg-gray-200 disabled:bg-gray-300 text-gray-700 font-semibold rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 transition-colors duration-200"
            >
              Back
            </button>
            <button
              type="button"
              onClick={onSkipGroupCode}
              disabled={loading}
              className="flex-1 py-3 px-4 bg-gray-100 hover:bg-gray-200 disabled:bg-gray-300 text-gray-700 font-semibold rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 transition-colors duration-200"
            >
              Skip
            </button>
            <button
              type="submit"
              disabled={loading || !groupCode.trim()}
              className="flex-1 py-3 px-4 bg-[#1086a4] hover:bg-[#0c6d85] disabled:bg-gray-400 text-white font-semibold rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1086a4] focus:ring-offset-2 transition-colors duration-200 shadow-sm"
            >
              {loading ? 'Verifying...' : 'Verify Code'}
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

EmailStep.propTypes = {
  onVerifyEmail: PropTypes.func.isRequired,
  onVerifyGroupCode: PropTypes.func.isRequired,
  onSkipGroupCode: PropTypes.func,
  error: PropTypes.string,
  loading: PropTypes.bool,
  noInvitation: PropTypes.bool,
  email: PropTypes.string
};

export default EmailStep;